import { EncryptionEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedEncryptionListSchema } from '../utils/schemas';
export const EncryptionResource = authResource({
    path: '/encryptions/:encryptionGUID',
    searchParams: {},
    schema: EncryptionEntity
}).extend((BaseResource) => ({
    getList: BaseResource.getList.extend({
        schema: paginatedEncryptionListSchema(EncryptionEntity)
    }),
    revoke: BaseResource.update.extend({
        path: '/encryptions/:encryptionGUID/revoke',
        method: 'POST',
        body: undefined
    }),
    update: BaseResource.update.extend({
        schema: undefined,
        optimistic: true
    }),
    shred: BaseResource.update.extend({
        path: '/encryptions/:encryptionGUID/shred',
        method: 'POST',
        body: undefined
    })
}));
